import { Box, Button, Typography } from '@mui/material';
import { LocationEntity } from '@peritasai/repository';
import { useTranslation } from 'react-i18next';
import { ListCard } from '../../../shared';
import {
  caseListScrollSx,
  listRowSx,
  locationHeadingSx,
  locationListRowContentSx,
  selectButtonSx,
  selectHubLocationTitleSx,
} from './styles';

type LocationListCardProps = {
  locations: LocationEntity[];
  showAll: boolean;
  showViewAll: boolean;
  onToggleViewAll: () => void;
  onSelect: (location: LocationEntity) => void;
};

export const LocationListCard = ({
  locations,
  showAll,
  showViewAll,
  onToggleViewAll,
  onSelect,
}: LocationListCardProps) => {
  const { t } = useTranslation(['periverse']);
  const listHeight = showAll ? '547px' : 'auto';

  return (
    <ListCard
      sx={
        showAll
          ? {
              width: { xs: '450px', md: '100%' },
              maxWidth: { xs: '450px', md: '100%' },
              height: 'calc(100vh - 187px)',
              overflow: 'hidden',
              gap: { xs: '40px', md: '16px' },
              padding: { xs: '40px 32px', md: '24px' },
              alignItems: { xs: 'center', md: 'stretch' },
            }
          : {
              width: { xs: '450px', md: '100%' },
              maxWidth: { xs: '450px', md: '100%' },
              overflow: 'visible',
              gap: { xs: '40px', md: '16px' },
              padding: { xs: '40px 32px', md: '24px' },
              alignItems: { xs: 'center', md: 'stretch' },
            }
      }
      showViewAll={showViewAll}
      expanded={showAll}
      onToggleViewAll={onToggleViewAll}
      viewAllLabel={
        showAll
          ? t('pages.releaseToDecon.hideAdditionalLocationsLabel')
          : t('pages.releaseToDecon.viewAllLocationsLabel')
      }
    >
      <Box sx={locationHeadingSx}>
        <Typography sx={selectHubLocationTitleSx}>Select hub location</Typography>
      </Box>
      <Box
        sx={{
          ...caseListScrollSx(showAll, listHeight),
          pr: { xs: '5px', md: '0px' },
          scrollbarGutter: showAll ? 'stable' : 'auto',
        }}
      >
        {locations.map((location) => (
          <Box key={location.id} sx={listRowSx}>
            <Box sx={locationListRowContentSx}>
              <Typography variant="body1">{location.name}</Typography>
              <Button
                variant="contained"
                size="small"
                onClick={() => onSelect(location)}
                sx={selectButtonSx}
              >
                Select
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </ListCard>
  );
};
